import { render, staticRenderFns } from "./ChatHelpModels.vue?vue&type=template&id=402e02d7"
import script from "./ChatHelpModels.vue?vue&type=script&lang=js"
export * from "./ChatHelpModels.vue?vue&type=script&lang=js"
import style0 from "./ChatHelpModels.vue?vue&type=style&index=0&id=402e02d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports